<template>
  <div class="g-recaptcha" :data-sitekey="recaptchaSiteKey" ref="recaptchaEl" />
</template>

<script setup>

  const emit = defineEmits(['verify']);
  const recaptchaSiteKey = useRuntimeConfig().public.recaptchaSiteKey;
  const recaptchaEl = ref();

  function loadScript() {
    if (document.querySelector('script#recaptcha')) return;

    return new Promise(async (resolve, reject) => {
      window.onRecaptchaLoad = function () {
        delete window.onRecaptchaLoad;
        resolve();
      };

      try {
        const {load} = useScriptTag('https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit');
        await load();
      } catch (e) {
        reject(e);
      }
    });
  }

  onMounted(async () => {
    const cb = res => emit('verify', res);
    await loadScript();

    grecaptcha?.render(recaptchaEl.value, {
      callback: cb,
      'expired-callback': cb
    });
  });

</script>
